import axiosInstance from '../utils/AxiosConfig';

export const addStaffException = async (request) => {
  const response = await axiosInstance.post(`/staff_schedule/exception`, request);
  return response.data.data;
};